import { useRiskReturnPage } from "@iliotech/data-wire";
import { RiskVsReturnScatter } from "src/components/__consumerCharts";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const RiskReturnScatterWidget = (props: ReportWidgetProps) => {
  const { items, getItemValue } = useRiskReturnPage(props.periodContext);

  const getItemValueSafe = (v?: string) => {
    return getItemValue(v ?? "") ?? 0;
  };

  return (
    <RiskVsReturnScatter
      items={items}
      periodString={props.periodContext.periodString}
      getItemValue={getItemValueSafe}
      isForReport={true}
      isHalfWidth={props.isHalfWidth}
      {...props}
    />
  );
};
